import * as React from "react"
import {Box, Typography} from "@mui/material";
import {formatNumber} from "@ui-seeker/utils";


export default function PercentageChartNewElementDiffBlock({ diff }) {
	let bgColor = 'transparent'
	if ((diff ?? 0) !== 0)
		bgColor = diff > 0 ? 'success.main' : 'error.main'

	return <Typography variant="caption" backgroundColor={bgColor}>
		{ (diff ?? null) !== null ? formatNumber(diff, {
			decimals: 1,
			suffix: 'p.p',
			prefix: diff > 0 ? '+' : null
		}) : 'N/A' }
	</Typography>
}